import React from 'react';
import AjaxSelect from '../../../ajax-select/AjaxSelect';

export default (props) => {
    const {
        key,
        value,
        defaultValue,
        forcedValue,
        data,
        rules,
        options,
        disabled,
        ruleRequired,
        isRequired,
        onChange
    } = props;

    return <AjaxSelect
        defaultValue={value}
        value={forcedValue}
        isSingle={false}
        clearable={options.clearable}
        disabled={disabled}
        prompt={options.prompt}
        dropdownHorizontalAlignment={options.dropdownHorizontalAlignment}
        onChange={onChange}
        ItemsSearchParcel={data.ItemsSearchParcel}
        ItemsFetchParcel={data.ItemsFetchParcel}
        renderOption={options.renderOption}
        renderSelection={options.renderSelection}
    />;
}
